export const isSortAction = <T>(
  action: any
): action is { sort: Sort<T> } =>
  action && typeof action === "object" && "sort" in action && !!action.sort;
